import type { IRequest } from '../../../../../common/interfaces/IRequest';
import { RequestStatus } from '../../../../../common/enums/RequestStatus';
import { ServiceCode } from '../../../../../common/enums/ServiceCode';
import { Osasc2Card } from './Osasc2Card';
import { OsasCard } from './OsasCard';

interface IOsasCardProps {
    request: IRequest;
}

export function OsasCards(props: IOsasCardProps) {
    return (
        <>
            {props.request.service.code === ServiceCode.OSASC2 && <Osasc2Card />}

            {[ServiceCode.OSASC1, ServiceCode.OSASO, ServiceCode.OSASVO, ServiceCode.OSASV].includes(
                props.request.service.code as ServiceCode
            ) &&
                props.request.status !== RequestStatus.completed && (
                    <OsasCard
                        slaaprecorderVerzenden={props.request.customControlData?.slaaprecorderVerzenden}
                        somnologyOrganizationType={props.request.customControlData?.somnologyOrganizationType}
                        typeSlaaprecorder={props.request.customControlData?.typeSlaaprecorder}
                    />
                )}
        </>
    );
}
